<template>
  <div>
    <div class="hit-rule-header">
      <AdminTitle title="命中规则详情" size="20px" bottom="0" />
      <el-button
        class="view-more"
        size="small"
        round
        @click="allRulesVisible = true"
        >查看更多</el-button
      >
    </div>
    <HitRuleTable :rows="effectiveRows" truncate-rule />
    <el-dialog
      title="命中规则详情"
      :visible.sync="allRulesVisible"
      width="70%"
      append-to-body
      :close-on-click-modal="false"
    >
      <HitRuleTable :rows="rows" :max-height="480" />
      <template slot="footer">
        <el-button size="small" @click="allRulesVisible = false"
          >关 闭</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import HitRuleTable from "./table.vue";

export default {
  name: "HitRuleDetail",
  components: { HitRuleTable },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      allRulesVisible: false,
    };
  },
  computed: {
    effectiveRows() {
      return this.rows
        .filter((row) => row.isEffective === true)
        .map((row, index) => ({ ...row, index: index + 1 }));
    },
  },
};
</script>

<style lang="scss" scoped>
.hit-rule-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.view-more {
  flex-shrink: 0;
  color: #606266;
  background: #f7f8fa;
  border-color: #f7f8fa;
  font-weight: 600;
}
</style>
